
import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Select, Store } from "@ngxs/store";
import { Select2Module, Select2SearchEvent, Select2UpdateEvent } from "ng-select2-component";
import { Observable } from "rxjs";
import { ButtonComponent } from "../../../shared/components/widgets/button/button.component";
import { countryCodes } from "../../../shared/data/country-code";
import { breadcrumb } from "../../../shared/interface/breadcrumb.interface";
import { Values } from "../../../shared/interface/setting.interface";
import { NotificationService } from "../../../shared/services/notification.service";
import { SettingState } from "../../../shared/store/state/setting.state";
import { ThemeOptionState } from "../../../shared/store/state/theme-option.state";
import { Option } from "../../../shared/interface/theme-option.interface";
import { SaveUserReqVM, UserLoginReqVM } from "../../../core/models/api/user.model";
import { PinCustomValidators } from '../../../shared/validator/pin-match';
import { TZDStoreUserService } from "../../../core/services/api/tzd-store-user.service";
import { APIResponseVM } from "../../../core/models/common/common.model";
import { DeviceTypeEnum, ResponseCodeEnum, SystemNameEnum } from "../../../core/enums/common.enum";
import { MasterService } from "../../../core/services/api/master.service";
import { AuthService } from "../../../core/services/api/auth.service";
import { Login } from "../../../shared/store/action/auth.action";
import { CommonState } from "../../../shared/store/state/common.state";

@Component({
  selector: "app-register",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    Select2Module,
    ButtonComponent,
  ],
  templateUrl: "./register.component.html",
  styleUrl: "./register.component.scss",
})
export class RegisterComponent {
  @Output() activeForm: EventEmitter<string> = new EventEmitter();

  @Select(SettingState.setting) setting$: Observable<Values>;
  @Select(ThemeOptionState.themeOptions) themeOption$: Observable<Option>;
  @Select(CommonState.commonHeaderDetails) commonHeaderDetails$: Observable<any>;
  pinVisible: boolean = false;
  pinConfirmationVisible: boolean = false;
  public form: FormGroup;
  public codes = countryCodes;
  public tnc = new FormControl(false, [Validators.requiredTrue]);
  // headerData: any;
  countryList:any[] = [];
  allCountryList:any[] = [];
  stateList:any[] = [];
  allStateList:any[] = [];
  cityList:any[] = [];
  allCityList:any[] = [];

  constructor(
    private masterService: MasterService,
    private formBuilder: FormBuilder,
    private tzdStoreUserService: TZDStoreUserService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private store: Store
  ) {    
    this.masterService.get_active_countrystatecity_list().subscribe({
      next: (resData: APIResponseVM<any>) => {
       if (resData.responseCode === ResponseCodeEnum.SUCCESS) {
        this.countryList = resData?.data?.map((res:any)=>{
        res['label'] = res?.countryName;
        res['value'] = res?.countryId;
        return res
        });
        this.allCountryList = [...this.countryList];
       }
      },
      error: (error: any) => {            
      },
    });
    this.form = this.formBuilder.group(
      {
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        country_code: [{ value: '91', disabled: true }],
        phone: ['', [
          Validators.required,
          Validators.pattern(/^[0-9]*$/),
        ]],
        countryId: ['', [Validators.required]],
        stateId: ['', [Validators.required]],
        cityId: ['', [Validators.required]],
        pin1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pin2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pin3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pin4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pin5: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pin6: ['', [Validators.required, Validators.pattern('^[0-9]$')]],   
        pinConfirmation1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pinConfirmation2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pinConfirmation3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pinConfirmation4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pinConfirmation5: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
        pinConfirmation6: ['', [Validators.required, Validators.pattern('^[0-9]$')]], 
      },
      {
        validator: [
          PinCustomValidators.MatchValidator(
            ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6'], 
            ['pinConfirmation1', 'pinConfirmation2', 'pinConfirmation3', 'pinConfirmation4', 'pinConfirmation5', 'pinConfirmation6']
          ),
          PinCustomValidators.PinLengthValidator(
            ['pin1', 'pin2', 'pin3', 'pin4', 'pin5', 'pin6']
          ),
        ],
      });  
      // this.commonHeaderDetails$.subscribe({
      //   next: (resData: any) => {
      //    this.headerData = resData?.data;
      //   },
      //   error: (error: any) => {            
      //   },
      // });  
  }

  get pinMatchError() {
    return this.form.hasError('mismatch') && this.form.get('pin1')?.touched;
  }

  get pinLengthError() {
    return this.form.hasError('pinLength') && this.form.get('pin1')?.touched;
  }

  searchDropDown(data: Select2SearchEvent,type:string) {
    switch (type) {
      case 'country':
        this.countryList = this.allCountryList.filter(item => item.label?.toLowerCase().includes(data?.search?.toLowerCase()));
        if (!data?.search) {
          this.countryList = [...this.allCountryList];
        }        
        break;
      case 'state':
        this.stateList = this.allStateList.filter(item => item.label?.toLowerCase().includes(data?.search?.toLowerCase()));
        if (!data?.search) {
          this.stateList = [...this.allStateList];
        }        
        break;
      case 'city':
        this.cityList = this.allCityList.filter(item => item.label?.toLowerCase().includes(data?.search?.toLowerCase()));
        if (!data?.search) {
          this.cityList = [...this.allCityList];
        }        
        break;
      default:
        break;
    }
  }

  selectCountryState(data: Select2UpdateEvent,type:string){
    if (type === 'country') {
      this.form.get('state')?.setValue('');
      this.form.get('city')?.setValue('');
      this.cityList = [];
      this.allCityList = [...this.cityList];
      this.stateList = [];
      this.allStateList = [...this.stateList];
      const dataList:any = this.countryList.find((res)=>res.countryId === data);
      if (dataList?.states) {
        this.stateList = dataList?.states?.map((res:any)=>{
          res['label'] = res?.stateName;
          res['value'] = res?.stateId;
          return res
          });;
        this.allStateList = [...this.stateList];      
      }
    }
    if (type === 'state') {
      this.form.get('city')?.setValue('');
      this.cityList = [];
      this.allCityList = [...this.cityList];
      const dataList:any = this.stateList.find((res)=>res.stateId === data);
      if (dataList?.cities) {
        this.cityList = dataList?.cities?.map((res:any)=>{
          res['label'] = res?.cityName;
          res['value'] = res?.cityId;
          return res
          });
        this.allCityList = [...this.cityList];        
      }
    }
  }

  submit() {
    this.form.markAllAsTouched();
    if (this.tnc.invalid) {
      return;
    }
    if (this.form.valid) {
      const payload: SaveUserReqVM = {
        firstName: this.form.value.firstName,
        lastName: this.form.value.lastName,
        email: this.form.value.email,
        password: this.concatenatePin(),
        phoneNo: this.form.value?.phone ? this.form.value?.phone.toString() : '',
        countryId: this.form.value?.countryId,
        stateId: this.form.value?.stateId,
        cityId: this.form.value?.cityId,
        userId: 0,
        bpId: 0,
        status: true,
      };
      this.tzdStoreUserService.save_user_business_partner(payload).subscribe({
        next: (resData: APIResponseVM<any>) => {
          if (resData?.responseCode === ResponseCodeEnum.SUCCESS) {
            this.notificationService.showSuccess(resData?.message);
            const payload:UserLoginReqVM = {
                    email: this.form.value.email,
                    password: this.concatenatePin(),
                    systemName: SystemNameEnum.DESKTOP,
                    deviceType: DeviceTypeEnum.DESKTOP,
                    isforcedlogin: false
                  }
                  this.authService.login(payload).subscribe({
                    next: (res:any)=>{
                      if (res?.responseCode === ResponseCodeEnum.SUCCESS) {
                        this.store.dispatch(new Login(res?.data))
                        this.notificationService.showSuccess(res?.message);
                      }else {
                        this.notificationService.showError(res?.Message ? res?.Message : res?.message);
                      }
                    },
                    error: (err)=>{
                        this.notificationService.showError(err?.message);
                    }
                  })
          }else {
            this.notificationService.showError(resData?.message);
          }
          // this.store.dispatch(new Register(this.form.value)).subscribe({
          //   complete: () => {
              // this.activeForm.emit("login");
          //   },
          // });        
        },
        error: (error: any) => {
          this.notificationService.showError(error)
        },
      });
    }
  }

  action(action: string) {
    this.activeForm.emit(action);
  }
	onPinChange(position: number, event: any): void {
		const input = event.target as HTMLInputElement;
		input.value = input.value.replace(/[^0-9]/g, '');
		const nextInput = document.querySelector(
			`input[formControlName="pin${position + 1}"]`
		) as HTMLInputElement;
		if (nextInput && event.target.value) {
			nextInput.focus();
		}
	}

	onPinKeyDown(position: number, event: KeyboardEvent): void {
		if (event.key === 'Backspace') {
			const currentInput = document.querySelector(
				`input[formControlName="pin${position}"]`
			) as HTMLInputElement;
			if (currentInput && currentInput.value === '') {
				const prevInput = document.querySelector(
					`input[formControlName="pin${position - 1}"]`
				) as HTMLInputElement;

				if (prevInput) {
					prevInput.focus();
				}
			}
		}
	}
  onPinConfirmationChange(position: number, event: any): void {
		const input = event.target as HTMLInputElement;
		input.value = input.value.replace(/[^0-9]/g, '');
		const nextInput = document.querySelector(
			`input[formControlName="pinConfirmation${position + 1}"]`
		) as HTMLInputElement;
		if (nextInput && event.target.value) {
			nextInput.focus();
		}
	}

	onPinKeyConfirmationDown(position: number, event: KeyboardEvent): void {
		if (event.key === 'Backspace') {
			const currentInput = document.querySelector(
				`input[formControlName="pinConfirmation${position}"]`
			) as HTMLInputElement;
			if (currentInput && currentInput.value === '') {
				const prevInput = document.querySelector(
					`input[formControlName="pinConfirmation${position - 1}"]`
				) as HTMLInputElement;

				if (prevInput) {
					prevInput.focus();
				}
			}
		}
	}
  concatenatePin(): string {
		const pin1 = this.form.value.pin1;
		const pin2 = this.form.value.pin2;
		const pin3 = this.form.value.pin3;
		const pin4 = this.form.value.pin4;
		const pin5 = this.form.value.pin5;
		const pin6 = this.form.value.pin6;

		return `${pin1}${pin2}${pin3}${pin4}${pin5}${pin6}`;
	}
}
